// extracted by mini-css-extract-plugin
export default {"recos":"m3-z","productCardOverride":"n3-z","rowHasBadge":"o3-z"};